var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app-button",class:[
        _vm.type ? 'app-button--' + _vm.type : '',
        _vm.buttonSize ? 'app-button--' + _vm.buttonSize : '',
        {
            'is-disabled': _vm.buttonDisabled,
            'is-loading': _vm.loading,
            'is-plain': _vm.plain,
            'is-bordered': _vm.border,
            'prepend': _vm.prepend,
            'append': _vm.append
        }
    ],attrs:{"disabled":_vm.buttonDisabled || _vm.loading,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"app-icon-loading"}):_vm._e(),(_vm.icon && !_vm.loading)?_c('i',{staticClass:"icon",class:_vm.icon}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }